const properties = [
  'Email',
  'First Name',
  'Last Name',
  'Address',
  'State',
  'City',
  'Zipcode',
  'Country',
  'Phone',
  'Gender',
  'Age',
  'Birthday',
  'Timezone',
];

export default properties;



// WEBPACK FOOTER //
// ./src/utils/sys-props.js